export class Patterns {
  public static readonly url = /(https?\:)\/\/(([^:\/?#\s]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#\s]*)(\?[^#\s]*|)(\#[^\s]*|)/;
  public static readonly richtext = /\[([^\]\[\|]+\|[^\|]+)\]/;

  public static create = (sources: string[], options?: { prefix?: string; postfix?: string; flags?: string }): RegExp => {
    const { flags, postfix, prefix } = { prefix: "", postfix: "", flags: "", ...options };
    return new RegExp(sources.map(s => prefix + s + postfix).join("|"), flags);
  };
}
